module.exports = __webpack_public_path__ + "static/img/tel.82a2fe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tel.png
// module id = 81Ru
// module chunks = 1